"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const R = react_1.default.createElement;
const LayeredChartLayerDesignerComponent_1 = __importDefault(require("./LayeredChartLayerDesignerComponent"));
const LayeredChartCompiler_1 = __importDefault(require("./LayeredChartCompiler"));
const TabbedComponent_1 = __importDefault(require("@mwater/react-library/lib/TabbedComponent"));
const uiComponents = __importStar(require("../../../UIComponents"));
const ColorComponent_1 = __importDefault(require("../../../ColorComponent"));
const ui = __importStar(require("@mwater/react-library/lib/bootstrap"));
const bootstrap_1 = require("@mwater/react-library/lib/bootstrap");
class LayeredChartDesignerComponent extends react_1.default.Component {
    // Determine if axes labels needed
    areAxesLabelsNeeded() {
        return !["pie", "donut"].includes(this.props.design.type);
    }
    // Updates design with the specified changes
    updateDesign(changes) {
        const design = lodash_1.default.extend({}, this.props.design, changes);
        return this.props.onDesignChange(design);
    }
    handleTypeChange = (type) => {
        return this.updateDesign({ type });
    };
    handleTransposeChange = (value) => {
        return this.updateDesign({ transpose: value });
    };
    handleHideLegendChange = (value) => {
        return this.updateDesign({ hideLegend: value });
    };
    handleStackedChange = (value) => {
        return this.updateDesign({ stacked: value });
    };
    handleProportionalChange = (value) => {
        return this.updateDesign({ proportional: value });
    };
    handleLabelsChange = (value) => {
        return this.updateDesign({ labels: value });
    };
    handleLabelsPopoutChange = (value) => {
        return this.updateDesign({ popoutSmallValues: value });
    };
    handlePercentageVisibilityChange = (value) => {
        return this.updateDesign({ hidePercentage: value });
    };
    handlePolarOrderChange = (value) => {
        return this.updateDesign({ polarOrder: value });
    };
    handleYThresholdsChange = (yThresholds) => {
        return this.updateDesign({ yThresholds });
    };
    handleLayerChange = (index, layer) => {
        const layers = this.props.design.layers.slice();
        layers[index] = layer;
        return this.updateDesign({ layers });
    };
    handleRemoveLayer = (index) => {
        const layers = this.props.design.layers.slice();
        layers.splice(index, 1);
        return this.updateDesign({ layers });
    };
    handleAddLayer = () => {
        const layers = this.props.design.layers.slice();
        layers.push({});
        return this.updateDesign({ layers });
    };
    handleXAxisLabelTextChange = (ev) => {
        return this.updateDesign({ xAxisLabelText: ev.target.value });
    };
    handleYAxisLabelTextChange = (ev) => {
        return this.updateDesign({ yAxisLabelText: ev.target.value });
    };
    handleToggleXAxisLabelClick = (ev) => {
        return this.updateDesign({ xAxisLabelText: this.props.design.xAxisLabelText != null ? null : "" });
    };
    handleToggleYAxisLabelClick = (ev) => {
        return this.updateDesign({ yAxisLabelText: this.props.design.yAxisLabelText != null ? null : "" });
    };
    handleYMinChange = (yMin) => {
        return this.updateDesign({ yMin });
    };
    handleYMaxChange = (yMax) => {
        return this.updateDesign({ yMax });
    };
    handleXAxisTickMultilineChange = (value) => {
        this.updateDesign({ xAxisTickMultiline: value });
    };
    renderLabels() {
        if (!this.props.design.type) {
            return;
        }
        const compiler = new LayeredChartCompiler_1.default({ schema: this.props.schema });
        return R("div", null, R("div", { className: "form-text text-muted" }, T `To edit title of chart, click on it directly`), this.areAxesLabelsNeeded()
            ? R("div", { className: "mb-3" }, R("span", null, R("label", { className: "text-muted" }, this.props.design.transpose ? T `Vertical Axis Label` : T `Horizontal Axis Label`), " ", R("button", { className: "btn btn-secondary btn-sm", onClick: this.handleToggleXAxisLabelClick }, this.props.design.xAxisLabelText != null ? T `Hide` : T `Show`)), this.props.design.xAxisLabelText != null
                ? R("input", {
                    type: "text",
                    className: "form-control form-control-sm",
                    value: this.props.design.xAxisLabelText,
                    onChange: this.handleXAxisLabelTextChange,
                    placeholder: compiler.compileDefaultXAxisLabelText(this.props.design, "en")
                })
                : undefined)
            : undefined, this.areAxesLabelsNeeded()
            ? R("div", { className: "mb-3" }, R("span", null, R("label", { className: "text-muted" }, !this.props.design.transpose ? T `Vertical Axis Label` : T `Horizontal Axis Label`), " ", R("button", { className: "btn btn-secondary btn-sm", onClick: this.handleToggleYAxisLabelClick }, this.props.design.yAxisLabelText != null ? T `Hide` : T `Show`)), this.props.design.yAxisLabelText != null
                ? R("input", {
                    type: "text",
                    className: "form-control form-control-sm",
                    value: this.props.design.yAxisLabelText,
                    onChange: this.handleYAxisLabelTextChange,
                    placeholder: compiler.compileDefaultYAxisLabelText(this.props.design)
                })
                : undefined)
            : undefined);
    }
    renderChartOptions() {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(bootstrap_1.Checkbox, { key: "hideLegend", value: this.props.design.hideLegend, onChange: this.handleHideLegendChange }, T `Hide legend`),
            react_1.default.createElement(bootstrap_1.Checkbox, { key: "xAxisTickMultiline", value: this.props.design.xAxisTickMultiline ?? true, onChange: this.handleXAxisTickMultilineChange }, T `Multiline X-Axis Labels`)));
    }
    renderType() {
        const chartTypes = [
            { id: "bar", name: T `Bar`, desc: T `Best for most charts` },
            { id: "pie", name: T `Pie`, desc: T `Compare ratios of one variable` },
            { id: "donut", name: T `Donut`, desc: T `Pie chart with center removed` },
            { id: "line", name: T `Line`, desc: T `Show how data changes smoothly over time` },
            { id: "spline", name: T `Smoothed Line`, desc: T `For noisy data over time` },
            { id: "scatter", name: T `Scatter`, desc: T `Show correlation between two number variables` },
            { id: "area", name: T `Area`, desc: T `For cumulative data over time` }
        ];
        const current = chartTypes.find(ct => ct.id === this.props.design.type);
        return (react_1.default.createElement(uiComponents.SectionComponent, { label: T `Chart Type` },
            react_1.default.createElement(uiComponents.ToggleEditComponent, { forceOpen: !this.props.design.type, label: current ? current.name : "", editor: (onClose) => (react_1.default.createElement(uiComponents.OptionListComponent, { hint: T `Select a Chart Type`, items: chartTypes.map(ct => ({
                        name: ct.name,
                        desc: ct.desc,
                        onClick: () => {
                            onClose(); // Close editor first
                            return this.handleTypeChange(ct.id);
                        }
                    })) })) }),
            this.renderOptions()));
    }
    renderLayer = (index) => {
        const style = {
            paddingTop: 10,
            paddingBottom: 10
        };
        return R("div", { style, key: index }, R(LayeredChartLayerDesignerComponent_1.default, {
            design: this.props.design,
            schema: this.props.schema,
            dataSource: this.props.dataSource,
            index,
            filters: this.props.filters,
            onChange: this.handleLayerChange.bind(null, index),
            onRemove: this.handleRemoveLayer.bind(null, index)
        }));
    };
    renderLayers() {
        if (!this.props.design.type) {
            return;
        }
        return R("div", null, lodash_1.default.map(this.props.design.layers, (layer, i) => this.renderLayer(i)), 
        // Only add if last has table
        this.props.design.layers.length > 0 && lodash_1.default.last(this.props.design.layers).table
            ? R("button", { className: "btn btn-link", type: "button", onClick: this.handleAddLayer }, R("span", { className: "fas fa-plus" }), " ", T `Add Another Series`)
            : undefined);
    }
    renderOptions() {
        const { design } = this.props;
        if (!design.type) {
            return;
        }
        // Can only stack if multiple series or one with color and not polar
        let canStack = !["pie", "donut"].includes(design.type) && design.layers.length > 0;
        if (design.layers.length === 1 && !design.layers[0].axes.color) {
            canStack = false;
        }
        // Don't include if transpose
        const canTranspose = !["pie", "donut"].includes(design.type);
        return R("div", { className: "text-muted" }, canTranspose ? (react_1.default.createElement(bootstrap_1.Checkbox, { inline: true, key: "transpose", value: design.transpose, onChange: this.handleTransposeChange }, T `Horizontal`)) : undefined, canStack ? (react_1.default.createElement(bootstrap_1.Checkbox, { inline: true, key: "stacked", value: design.stacked, onChange: this.handleStackedChange }, T `Stacked`)) : undefined, canStack ? (react_1.default.createElement(bootstrap_1.Checkbox, { inline: true, key: "proportional", value: design.proportional, onChange: this.handleProportionalChange }, T `Proportional`)) : undefined, react_1.default.createElement(bootstrap_1.Checkbox, { inline: true, key: "labels", value: design.labels || false, onChange: this.handleLabelsChange }, T `Show Values`), ["pie", "donut"].includes(design.type)
            ? [
                react_1.default.createElement(bootstrap_1.Checkbox, { key: "percentVisible", inline: true, value: design.hidePercentage, onChange: this.handlePercentageVisibilityChange }, T `Hide Percentage`),
                react_1.default.createElement(bootstrap_1.Select, { size: "sm", value: design.polarOrder ?? "desc", onChange: this.handlePolarOrderChange, options: [
                        { value: "desc", label: T `Descending Order` },
                        { value: "asc", label: T `Ascending Order` },
                        { value: "natural", label: T `Natural Order` }
                    ], inline: true })
            ]
            : undefined, design.labels && design.type === "bar" && !design.transpose
            ? R("div", null, react_1.default.createElement(bootstrap_1.Checkbox, { inline: true, key: "labels", value: design.popoutSmallValues || false, onChange: this.handleLabelsPopoutChange }, T `Show Popout labels for small values`))
            : undefined);
    }
    renderThresholds() {
        // Doesn't apply to polar
        if (this.props.design.type && !["pie", "donut"].includes(this.props.design.type)) {
            return R(uiComponents.SectionComponent, { label: T `Y Threshold Lines` }, R(ThresholdsComponent, {
                thresholds: this.props.design.yThresholds,
                onThresholdsChange: this.handleYThresholdsChange,
                showHighlightColor: this.props.design.type === "bar"
            }));
        }
        return null;
    }
    renderYRange() {
        // Doesn't apply to polar
        if (this.props.design.type && !["pie", "donut"].includes(this.props.design.type)) {
            return R(uiComponents.SectionComponent, { label: T `Y Axis Range` }, R(LabeledInlineComponent, { key: "min", label: T `Min:` }, R(ui.NumberInput, {
                decimal: true,
                style: { display: "inline-block" },
                size: "sm",
                value: this.props.design.yMin,
                onChange: this.handleYMinChange,
                placeholder: T `Auto`
            })), "  ", R(LabeledInlineComponent, { key: "label", label: T `Max:` }, R(ui.NumberInput, {
                decimal: true,
                style: { display: "inline-block" },
                size: "sm",
                value: this.props.design.yMax,
                onChange: this.handleYMaxChange,
                placeholder: T `Auto`
            })));
        }
        return null;
    }
    render() {
        const tabs = [];
        tabs.push({
            id: "design",
            label: T `Design`,
            elem: R("div", { style: { paddingBottom: 200 } }, R("br"), this.renderType(), this.renderLayers(), this.renderThresholds(), this.renderYRange())
        });
        if (this.props.design.type) {
            tabs.push({
                id: "labels",
                label: T `Labels`,
                elem: R("div", null, R("br"), this.renderLabels())
            });
        }
        tabs.push({
            id: "options",
            label: T `Options`,
            elem: R("div", null, R("br"), this.renderChartOptions())
        });
        return R(TabbedComponent_1.default, {
            initialTabId: "design",
            tabs
        });
    }
}
exports.default = LayeredChartDesignerComponent;
// Thresholds are lines that are added at certain values
class ThresholdsComponent extends react_1.default.Component {
    handleAdd = () => {
        const thresholds = (this.props.thresholds || []).slice();
        thresholds.push({ value: null, label: "", highlightColor: null });
        return this.props.onThresholdsChange(thresholds);
    };
    handleChange = (index, value) => {
        const thresholds = (this.props.thresholds || []).slice();
        thresholds[index] = value;
        return this.props.onThresholdsChange(thresholds);
    };
    handleRemove = (index) => {
        const thresholds = (this.props.thresholds || []).slice();
        thresholds.splice(index, 1);
        return this.props.onThresholdsChange(thresholds);
    };
    render() {
        return R("div", null, lodash_1.default.map(this.props.thresholds || [], (threshold, index) => {
            return R(ThresholdComponent, {
                threshold,
                onThresholdChange: this.handleChange.bind(null, index),
                onRemove: this.handleRemove.bind(null, index),
                showHighlightColor: this.props.showHighlightColor
            });
        }), R("button", { type: "button", className: "btn btn-sm btn-link", onClick: this.handleAdd }, R("i", { className: "fa fa-plus" }), " ", T `Add Y Threshold`));
    }
}
class ThresholdComponent extends react_1.default.Component {
    render() {
        return R("div", null, R(LabeledInlineComponent, { key: "value", label: T `Value:` }, R(ui.NumberInput, {
            decimal: true,
            style: { display: "inline-block" },
            size: "sm",
            value: this.props.threshold.value,
            onChange: v => this.props.onThresholdChange(lodash_1.default.extend({}, this.props.threshold, { value: v }))
        })), "  ", R(LabeledInlineComponent, { key: "label", label: T `Label:` }, R(ui.TextInput, {
            style: { display: "inline-block", width: "8em" },
            size: "sm",
            value: this.props.threshold.label,
            onChange: (v) => this.props.onThresholdChange(lodash_1.default.extend({}, this.props.threshold, { label: v }))
        })), "  ", this.props.showHighlightColor
            ? R(LabeledInlineComponent, { key: "color", label: T `Highlight color:` }, R("div", { style: { verticalAlign: "middle", display: "inline-block" } }, R(ColorComponent_1.default, {
                color: this.props.threshold.highlightColor,
                onChange: (v) => this.props.onThresholdChange(lodash_1.default.extend({}, this.props.threshold, { highlightColor: v }))
            })))
            : undefined, "  ", R("button", { className: "btn btn-sm btn-link", onClick: this.props.onRemove }, R("i", { className: "fa fa-remove" })));
    }
}
function LabeledInlineComponent(props) {
    return R("div", { style: { display: "inline-block" } }, R("label", { className: "text-muted" }, props.label), " ", props.children);
}
